import Cookies from 'js-cookie';

export const getCsrfToken = function() {
    var requestToken = Cookies.get('X-XSRF-REQUEST-TOKEN');
    if(requestToken) return requestToken;
    return "0";
}


export const handleCsrfFailure = function () {
    alert("Sorry, the application has failed to process your request, please refresh and try again");
    window.location.reload();
}